export default "__VITE_ASSET__GSv5wpBw__"